import './category.scss';

export default () => {

};
